import type { VoidFunctionComponent } from 'react';

import InfoPanel from '../../../generic/InfoPanel';

const ProjectSummaryV2: VoidFunctionComponent = () => {
  return (
    <div className="padding-top-sm container">
      <InfoPanel>Project Summary V2 Coming Soon</InfoPanel>
    </div>
  );
};

export default ProjectSummaryV2;
